/**
 * @description: 商品套餐销售汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-stxh-report">
        <div class="stxh-list">
            <p class="p-hint">1、注：统计的数据已扣除退货数量。2、当天营业数据就只能单个营业日，历史数据支持一个月内的数据查询</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="stxhTime">
                        <input type="text" class="form-control laydate-icon" v-model="stxhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="stxhEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stxh_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-6">商品套餐类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stxh_goods_package" data-placeholder="请选择商品套餐类型">
                        <option value="0">全部</option>
                    </select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-6">商品套餐名称:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="stxh_name" placeholder="请输入商品套餐名称">
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">销售总量:</label>
                <div class="list-total" ref="stxh_xs_total"></div>
                <label class="list-label-4">销售总额:</label>
                <div class="list-total" ref="stxh_xs_amount"></div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitStxhTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getStxhExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="stxhList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="stxhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='stxhExport_allcheck' @click='stxhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxhExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxhExport_checkModel' value="wares_type_name">
                            <label>商品套餐类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxhExport_checkModel' value="package_name">
                            <label>商品套餐名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxhExport_checkModel' value="package_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxhExport_checkModel' value="quantity">
                            <label>销售总量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxhExport_checkModel' value="actual_amount">
                            <label>销售单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxhExport_checkModel' value="actual_amount_total">
                            <label>销售总额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='stxhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='stxhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                stxhStartTime: "",
                stxhEndTime: "",
                stxh_name: '',
                stxhExport_allcheck: false,
                c_stxhExport_allcheck: false,
                stxhExport_checkModel: [],
                stxhExport_checkData: ['shop_name', 'wares_type_name', 'package_name', 'package_unit_name', 'quantity', 'actual_amount', 'actual_amount_total'],
                stxhExport_type: 1,
            }
        },
        watch: {
            stxhExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.stxhExport_checkModel.length >= this.stxhExport_checkData.length) {
                        this.stxhExport_allcheck = true;
                        this.c_stxhExport_allcheck = true;
                    } else {
                        this.stxhExport_allcheck = false;
                        this.c_stxhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.stxhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.stxhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.getGoodsPackageType(); // 商品套餐类型
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.stxhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.stxhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.stxhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.stxhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.stxhTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.stxhStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.stxhEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.stxh_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.stxh_shop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitStxhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取商品套餐类型
			getGoodsPackageType() {
				const _this = this;
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
                        let arr = []
						$.each(res.data.response.result.data, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.stxh_goods_package).select2({
							data: arr,
							width: '100%'
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},



            // 表格
            innitStxhTable: function() {
                let _this = this;
                $(_this.$refs.stxhList).bootstrapTable('destroy');
                $(_this.$refs.stxhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getStxhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "wares_type_name",
                        title: "商品套餐<br />类型",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "package_name",
                        title: "商品套餐<br />名称",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "package_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "销售总量",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "actual_amount",
                        title: "销售单价",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "actual_amount_total",
                        title: "销售总额",
                        width: "5%",
                        valign: "middle"
                    }],
                });
            },
            getStxhList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.stxhStartTime,
                            "end_date": _this.stxhEndTime,
                            "shop_id": $(_this.$refs.stxh_shop).val(),
                            "ware_goods_type": $(_this.$refs.stxh_goods_package).val(),
                            "wares_name": _this.stxh_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getWaresCountList',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(pageNumber == '1') {
                                _this.stxh_table_total = data.response.result.data.count;
                                $(_this.$refs.stxh_xs_total).text(data.response.result.data.quantity_total);
                                $(_this.$refs.stxh_xs_amount).text(data.response.result.data.actual_amount_total);
                            }
                            params.success({
                                total: _this.stxh_table_total,
                                rows: data.response.result.data.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getStxhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/getWaresCountExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.stxhExport_checkModel = data.response.result.export_fields;
                                _this.stxhExport_type = data.response.result.export_type;
                            } else {
                                _this.stxhExport_checkModel = _this.stxhExport_checkData;
                                _this.stxhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.stxhExport_alert)
                }, function() {
                    _this.exportStxhList();
                });
            },
            // 导出字段全选
            stxhExportCheckedAll: function(type) {
                let _this = this;
                _this.stxhExport_allcheck = _this.c_stxhExport_allcheck;
                if(!_this.stxhExport_allcheck) { // 实现全选
                    _this.stxhExport_checkModel = [];
                    _this.stxhExport_checkData.forEach(function(item) {
                        _this.stxhExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.stxhExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportStxhList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.stxhExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/getWaresCountExport" +
                    "?start_date=" + _this.stxhStartTime +
                    "&end_date=" + _this.stxhEndTime +
                    "&shop_id=" + $(_this.$refs.stxh_shop).val() +
                    "&ware_goods_type=" + $(_this.$refs.stxh_goods_package).val() +
                    "&wares_name=" + _this.stxh_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.stxhExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>